import _ from "lodash";
import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import BaseContentDetailsPageView from "scripts/views/baseContentDetailsPageView";
import ContentDetailsAudioPageNavView from "scripts/views/contentDetailsAudioPageNavView";
import templateContentDetailsAudioPage from "templates/contentDetailsAudioPage.hbs";

const chan = Backbone.Radio.channel;

class ContentDetailsAudioPageView extends BaseContentDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
    bookshelfService = inject("bookshelfService"),
  ) {
    super(
      options,
      breadcrumbService,
      connectionService,
      securityService,
      bookshelfService,
    );
  }

  get template() {
    return templateContentDetailsAudioPage;
  }

  get events() {
    return _.extend({}, super.events, {
      "click #bb-audio-details-player-button": "onPlayAudio",
    });
  }

  createNavView() {
    const organizationProperties = this.securityService.getUser().getActiveOrganizationProperty(
        "organizationProperties",
    );

    return new ContentDetailsAudioPageNavView({
      model: this.model,
      organizationProperties,
    });
  }

  onPlayAudio() {
    chan("display").request("playAudio", this.mediaModel);
    chan("tracking").trigger("viewer:click", this.mediaModel); // not listened to
    return false;
  }
}

export default ContentDetailsAudioPageView;
